import React from 'react';
import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { colors } from 'Constants/Colors';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundImage: `linear-gradient(to right,${colors.GREEN}, ${colors.GREEN_LIGHT})`,
  },
}));

export default function CustomizedProgressBars({ value = 50 }) {
  return <BorderLinearProgress variant="determinate" value={value} />;
}
